import { route } from '@/ziggy-shim';
import { api, apiConfig, CastValue } from './LaravelClient';

export default {
  async store(tenderId: Id, signedParams: unknown, data: ApiRequests['api.v1.subcontractor.tenders.items.store']) {
    return await apiConfig(route('api.v1.subcontractor.tenders.items.store', tenderId), 'post', {
      params: signedParams,
      paramsSerializer: {
        serialize: (params) => {
          return new URLSearchParams(params as Record<string, string>).toString();
        },
      },
    }, {
      data,
      casts: {
        rate: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        amount: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },
};
